import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { catchError, firstValueFrom, of, timeout } from 'rxjs';
import { resolveLocale, setDocumentDirection, SupportedLocale } from './locale';

/** How long the app waits for the translations before starting anyway. */
export const TRANSLATIONS_LOAD_TIMEOUT = 5000;

export function provideI18n(): EnvironmentProviders {
  const locale = getLocale();
  setDocumentDirection(locale);

  return makeEnvironmentProviders([
    provideTranslateService({
      fallbackLang: locale,
      loader: provideTranslateHttpLoader({ prefix: './i18n/', suffix: '.json' }),
    }),
    // Waits for the translations before the first render, so that raw keys are not displayed.
    provideAppInitializer(() =>
      firstValueFrom(
        inject(TranslateService)
          .use(locale)
          .pipe(
            timeout(TRANSLATIONS_LOAD_TIMEOUT),
            catchError(() => of(null)),
          ),
      ),
    ),
  ]);
}

export function getLocale(): SupportedLocale {
  return resolveLocale();
}
